import { render, staticRenderFns } from "./menu-pending-verification.vue?vue&type=template&id=4e79a73e&"
import script from "./menu-pending-verification.vue?vue&type=script&lang=js&"
export * from "./menu-pending-verification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports